export enum OfferSurface {
  TrackingPage = "tracking-page",
  ReturnsConfirmation = "returns-confirmation",
  HostedPage = "hosted-page",
  ThankYou = "thank-you",
  OrderStatus = "order-status",
}
